import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SwipeableTextStepper from "./SwipeableTextStepper";
import BlockIcon from "@mui/icons-material/Block";

const useStyles = makeStyles({
  container: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "3rem",
  },
  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletext1: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    // fontWeight: "300 !important",
    fontSize: "18px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    // marginLeft: "20px",
  },
});

const ExperienceCards = ({ weDetails, skillsMaster }) => {
  const classes = useStyles();
  const [newSkillData, setNewSkillData] = useState([]);

  // full name of skills from skillsMaster
  useEffect(() => {
    let newSkillDataArr = [];

    weDetails?.map((position) => {
      let newSkillArr = [];
      position?.skills.forEach((skill) => {
        newSkillArr.push({
          skill,
          fullName: skillsMaster[skill]?.fullName,
          category: skillsMaster[skill]?.category,
        });
      });

      newSkillArr?.sort((a, b) => {
        // Convert both fullNames to lowercase to ensure case-insensitive sorting
        const fullNameA = a.fullName;
        const fullNameB = b.fullName;

        // Compare the fullNames and return the comparison result
        if (fullNameA < fullNameB) return -1;
        if (fullNameA > fullNameB) return 1;
        return 0;
      });

      position.skillArrObject = newSkillArr;
      newSkillDataArr.push(position);
    });
    setNewSkillData(newSkillDataArr);
  }, [weDetails, skillsMaster]);

  // colors to use for skills

  return weDetails?.length ? (
    <>
      <Grid
        item
        xs={12}
        style={{ marginTop: "25px", marginBottom: "25px", display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="h6">Work Experience</Typography>
      </Grid>
      {newSkillData?.map((position) => (
        <Box
          style={{
            border: "solid 1px #C4C4C4",
            borderRadius: "8px",
            width: "100%",
            marginBottom: "25px",
          }}
        >
          <Grid container style={{ marginTop: "5px" }}>
            <Grid item xs={8} style={{ marginTop: "3px" }}>
              <Typography className={classes.roletext1} sx={{ marginLeft: "20px" }}>
                {position?.title !== "" ? `${position?.title},` : "Position Not Available,"}{" "}
                <span style={{ fontWeight: "500" }}>
                  {position?.company !== "" ? `${position?.company}` : "Company Not Available"}
                </span>
                {position?.location !== "" ? `, ${position?.location}` : "."}
              </Typography>
            </Grid>
            <Grid item xs={4} style={{ marginTop: "3px" }}>
              <Typography className={classes.roletext1} sx={{ textAlign: "center" }}>
                {position?.startDate !== "" ? position?.startDate : "Start Date NA"} -{" "}
                {position?.endDate !== "" ? position?.endDate : "End Date NA"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={8} style={{ marginTop: "3px" }}>
              <Typography className={classes.leftSideContaint1} sx={{ marginLeft: "0px" }}>
                <ul>
                  {position?.itemList?.map((item) => (
                    <li style={{ lineHeight: "14px !important", marginTop: "7px" }}>{item} </li>
                  ))}
                </ul>
              </Typography>
            </Grid>
            <Grid item xs={4} spacing={1} style={{ marginTop: "3px", height: "100% !importent" }}>
              {/* crousel for skills */}
              <SwipeableTextStepper skillArrObject={position?.skillArrObject} />
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  ) : (
    <div style={{ marginBottom: "25px" }}>
      <Grid
        item
        xs={12}
        style={{ marginTop: "25px", marginBottom: "25px", display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="h6">Work Experience</Typography>
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "20px",
        }}
        className={classes.roletype}
      >
        <span>
          <BlockIcon />
        </span>{" "}
        <Typography sx={{ marginLeft: "5px", marginBottom: "13px" }} className={classes.roletype}>
          Work Experience Not Available.
        </Typography>
      </div>
    </div>
  );
};

export default ExperienceCards;
